import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Alert, { formatContentWithEmoji } from '../alert';

const FIVE_SECONDS_IN_MS = 5000;

class DashboardAlerts extends Component {
  onLoginClick = () => {
    window.$('#signin').modal('show');
  }

  showMakeChangesModal = () => {
    this.props.showMakeChangesModal();
  }

  showInviteModal = () => {
    this.props.showInviteModal();
  }

  showCommitModal = () => {
    this.props.showCommitModal();
  }

  showResolveIssuesModal = () => {
    this.props.showResolveIssuesModal();
  }

  renderMustBeLoggedInToInvite() {
    if (!this.props.isMustBeLogedInToInviteVisible) return null;
    const message = (
      <FormattedMessage
        id="purchaseDashboard.alerts.mustBeLogedInToInvite"
        defaultMessage="You must be logged in to send invitations. {logIn}"
        values={{
          logIn: (
            <a href="#signin"
              onClick={this.onLoginClick}
            >
              <FormattedMessage
                id="purchaseDashboard.alerts.logInNow"
                defaultMessage="Login now"
              />
            </a>
          ),
        }}
      />
    );

    return (
      <Alert type="warning">
        {formatContentWithEmoji(message, '‼️')}
      </Alert>
    )
  }

  renderCommitDeadlineExpired() {
    if (!this.props.isCommitDeadlineExpireAlertVisible) return null;

    return (
      <Alert type="warning">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaeDashboard.alerts.deadlineExpired.title"
              defaultMessage="The invite deadline expired"
            />, '‼️')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.deadlineExpired.extend"
          defaultMessage="Extend it to let more people contribute. {contact}"
          values={{
            contact: (
              <b>
                <a className="ml-4" href="mailto:info@keytravel.com?subject=Extend commit deadline">
                  <FormattedMessage
                    id="purchaseDashboard.alerts.deadlineExpired.contactUs"
                    defaultMessage="Contact us to extend it"
                  />
                </a>
              </b>
            )
          }}
        />
      </Alert>
    );
  }

  renderGroupIsFullAlert() {
    if (!this.props.isGroupFullForInviteeAlertVisible) return null;

    const { organizerEmail } = this.props.purchase.group;

    return (
      <Alert type="warning">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.groupFull.title"
              defaultMessage="This group is full"
            />, '‼️')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaeDashboard.alerts.groupFull.askOrganizer"
          defaultMessage="If you aren't a contributor yet ask your organizer to expand the group size to join"
        />
        <b>
          <a className="ml-4" href={`mailto:${organizerEmail}`}>
            <FormattedMessage
              id="purchaseDashboard.alerts.groupFull.contactOrganizer"
              defaultMessage="Contact organizer"
            />
          </a>
        </b>
      </Alert>
    );
  }

  renderMakePurchasePrompt() {
    const { slug } = this.props.purchase;

    return (
      <a className="ml-4" href={`/purchases/${slug}/make-purchase`}>
        <FormattedMessage
          id="purchaseDashboard.alerts.makePurchase.propmt"
          defaultMessage="Make purchase"
        />
      </a>
    );
  }

  renderCommitPrompt(label) {
    return (
      <button className="btn-link ml-4" type="button" onClick={this.showCommitModal}>
        <b>{label}</b>
      </button>
    );
  }

  renderPurchaseSavedAlert() {
    if (!this.props.isPurchaseSavedAlertVisible) return null;

    return (
      <Alert
        type='success'
        autoCloseDelay={FIVE_SECONDS_IN_MS}
        onClose={this.props.hidePurchaseSavedAlert}
      >
        <i
          className='fa fa-check-circle-o mr-2'
          style={{ fontSize: '16px' }}
        />

        <strong>
          <FormattedMessage
            id='purchaseDashboard.alerts.savePurchase.title'
            defaultMessage='Success!'
          />
        </strong>
        &nbsp;
        <FormattedMessage
          id='purchaseDashboard.alerts.savePurchase.message'
          defaultMessage='Your payment information has been saved. Your contribution will be charged when the group makes a payment.'
        />
      </Alert>
    );
  }

  renderMakePurchaseAlert() {
    if (!this.props.isMakePurchaseAlertVisible) return null;

    return (
      <Alert type="success">
        <strong>  {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.makePurchase.title"
              defaultMessage="Your group is full"
            />, '🎉')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.makePurchase.completePurchase"
          defaultMessage="so complete your purchase"
        />
        <b>{this.renderMakePurchasePrompt()}</b>
      </Alert>
    );
  }

  renderMakePurchaseOrEditAlert() {
    if (!this.props.isMakePurchaseOrEditAlertVisible) return null;

    return (
      <Alert type="success">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.makeOrEdit.title"
              defaultMessage="Your group is full"
            />, '🎉')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.makeOrEdit.complete"
          defaultMessage="so complete your purchase or make room for more."
        />
        <b>
          {this.renderMakePurchasePrompt()}
        </b>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.makeOrEdit.or"
          defaultMessage="or"
        />
        {' '}
        <button className="btn-link" type="button" onClick={this.showMakeChangesModal}>
          <b><FormattedMessage
            id="purchaseDashboard.alerts.makeOrEdit.edit"
            defaultMessage="Edit group size"
          /></b>
        </button>
      </Alert>
    );
  }

  renderPurchaseExpiredAlert() {
    if (!this.props.isPurchaseExpiredAlertVisible) return null;

    const { merchant: { supportEmail } } = this.props.purchase;

    return (
      <Alert type="warning">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.offerExpired.title"
              defaultMessage="This offer has expired"
            />, '‼️')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.offerExpired.reason"
          defaultMessage="Your group didn't make the necessary payments in time."
        />
        {
          supportEmail &&
            <strong>
              <a className="ml-4" href={`mailto:${supportEmail}?subject=Request extension`}>
                <FormattedMessage
                  id="purchaseDashboard.alerts.offerExpired.requestExtension"
                  defaultMessage="Request extension"
                />
              </a>
            </strong>
        }
      </Alert>
    );
  }

  renderPurchaseIncompleteAfterRemoveAlert() {
    if (!this.props.isPurchaseIncompleteAfterRemoveAlertVisible) return null;

    return (
      <Alert type="warning">
        <strong>
          <FormattedMessage
            id="purchaseDashboard.alerts.incompleteAfterRemove.title"
            defaultMessage="Contributor(s) Removed."
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.incompleteAfterRemove.cantMakePurchase"
          defaultMessage="You now don`t have enough contributors to make the purchase"
        />
        <button className="btn-link ml-4" type="button" onClick={this.showInviteModal}>
          <b><FormattedMessage
            id="purchaseDashboard.alerts.incompleteAfterRemove.invite"
            defaultMessage="Send invites"
          /></b>
        </button>
      </Alert>
    );
  }

  renderOrganizerCoveredSharesAlert() {
    if (!this.props.isOrganizerCoveredSharesAlertVisible) return null;

    return (
      <Alert type="success">
        <strong>
          <FormattedMessage
            id="purchaseDashboard.alerts.orgCoveredShares.title"
            defaultMessage="Succesfully updated your share."
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaeDashboard.alerts.orgCoveredShares.canMakePurchase"
          defaultMessage="Your group has enough contributors for you to complete your purchase."
        />
        <strong>
          {this.renderMakePurchasePrompt()}
        </strong>
      </Alert>
    );
  }

  renderMembershipChargeFailedAlert() {
    if (!this.props.isMembershipChargeFailedAlertVisible) return null;

    return (
      <Alert type="warning">
        <strong>
          <FormattedMessage
            id="purchaseDashboard.alerts.chargeFailed.title"
            defaultMessage="Your payment failed."
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.chargeFailed.solution"
          defaultMessage="Please update your payment method or risk losing your spot."
        />
        {
          this.renderCommitPrompt(<FormattedMessage
            id="purchaseDashboard.alerts.chargeFailed.updatePaymentMethod"
            defaultMessage="Update payment method"
          />)
        }
      </Alert>
    );
  }

  renderShortMembershipAlert() {
    if (!this.props.isShortMembershipAlertVisible) return null;

    return (
      <Alert type="warning">
        <strong>
          <FormattedMessage
            id="purchaseDashboard.alerts.short.title"
            defaultMessage="Cost Updated."
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.short.reason"
          defaultMessage="The cost for your share is more than you agreed to contribute.
              Accept the new cost to stay in the group"
        />
        {
          this.renderCommitPrompt(<FormattedMessage
            id="purchaseDashboard.alerts.short.accept"
            defaultMessage="Accept new cost"
          />)
        }
      </Alert>
    );
  }

  renderContributorsWithIssuesAlert() {
    if (!this.props.isContributorsWithIssuesAlertVisible) return null;

    const otherIssuesCount = (this.props.otherMembershipsWithIssues || []).length;

    return (
      <Alert type="warning">
        <strong>
          <FormattedMessage
            id="purchaseDashboard.alerts.issues.title"
            defaultMessage="{otherIssuesCount} member payment(s) have payment issues."
            values={{ otherIssuesCount }}
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.issues.mustTakeActions"
          defaultMessage="You must take action to complete your group`s purchase."
        />
        <button
          className="btn-link ml-4"
          type="button"
          onClick={this.showResolveIssuesModal}
        >
          <b><FormattedMessage
            id="purchaseDashboard.alerts.issues.resolve"
            defaultMessage="Resolve Issues"
          /></b>
        </button>
      </Alert>
    );
  }

  renderMembersRemovedAlert() {
    if (!this.props.isMembersRemovedAlertVisible) return null;

    return (
      <Alert type="success" autoCloseDelay={FIVE_SECONDS_IN_MS}>
        <i
          className='fa fa-check-circle-o mr-2'
          style={{ fontSize: '16px' }}
        />
        <strong>
          <FormattedMessage
            id="purchaseDashboard.membersRemoved.title"
            defaultMessage="Success!"
          />
        </strong>
        &nbsp;
        <FormattedMessage
          id="purchaseDashboard.alerts.membersRemoved.description"
          defaultMessage=" These member(s) have been removed from the group"
        />
      </Alert>
    );
  }

  renderWithdrawalAlert() {
    if (!this.props.isWithdrawalAlertVisible) return null;

    return (
      <Alert type="success">
        <i
          className='fa fa-check-circle-o mr-2'
          style={{ fontSize: '16px' }}
        />
        <strong>
          <FormattedMessage
            id="purchaseDashboard.withdrawalAlert.title"
            defaultMessage="Success!"
          />
        </strong>
        &nbsp;
        <FormattedMessage
          id="purchaseDashboard.alerts.withdrawalAlert.description"
          defaultMessage="Your withdrawal has been completed. Was this a mistake?"
        />
        &nbsp;
        <button
          type="button"
          className="btn-link ml-1"
          onClick={() => {
            this.showCommitModal();
            this.props.hideWithdrawalAlert();
          }}
        >
          <b>
            <FormattedMessage
              id="purchaseDashboard.alerts.withdrawalAlert.contributeAgain"
              defaultMessage="Contribute again"
            />
          </b>
        </button>
      </Alert>
    );
  }

  renderPaymentProcessingAlert() {
    if (!this.props.isPaymentProcessingAlertVisible) return null;

    const { displayName } = this.props.purchase.merchant;

    return (
      <Alert type="success">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.paymentProcessing.title"
              defaultMessage="Payment processing!"
            />, '🎉')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.paymentProcessing.description"
          defaultMessage="Waiting for { merchant } to confirm your purchase."
          values={{ merchant: displayName }}
        />
      </Alert>
    );
  }

  renderEmailReminderSentAlert() {
    if (!this.props.isEmailReminderSentAlertVisible) return null;

    return (
      <Alert type="success">
        <FormattedMessage
          id="purchaseDashboard.alerts.remindersSent"
          defaultMessage="Reminders sent!"
        />
      </Alert>
    );
  }

  renderGroupCompletedAlert() {
    if (!this.props.isGroupCompletedAlertVisible) return null;

    const { displayName } = this.props.purchase.merchant;

    return (
      <Alert type="success">
        <strong>
          {
            formatContentWithEmoji(<FormattedMessage
              id="purchaseDashboard.alerts.groupCompleted.title"
              defaultMessage="The group is complete!"
            />, '🎉')
          }
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.alerts.groupCompleted.withMerchant"
          defaultMessage="The purchase has been made with { merchant }."
          values={{ merchant: displayName }}
        />
      </Alert>
    );
  }

  render() {
    return (
      <div className="dashboard-alerts">
        {this.renderCommitDeadlineExpired()}
        {this.renderGroupIsFullAlert()}
        {this.renderPurchaseSavedAlert()}
        {this.renderMakePurchaseAlert()}
        {this.renderMakePurchaseOrEditAlert()}
        {this.renderPurchaseExpiredAlert()}
        {this.renderPurchaseIncompleteAfterRemoveAlert()}
        {this.renderOrganizerCoveredSharesAlert()}
        {this.renderMembershipChargeFailedAlert()}
        {this.renderShortMembershipAlert()}
        {this.renderContributorsWithIssuesAlert()}
        {this.renderMembersRemovedAlert()}
        {this.renderPaymentProcessingAlert()}
        {this.renderEmailReminderSentAlert()}
        {this.renderGroupCompletedAlert()}
        {this.renderMustBeLoggedInToInvite()}
        {this.renderWithdrawalAlert()}
      </div>
    );
  }

}

export default DashboardAlerts;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/alerts.js